define('modules/global/ad-free-redirect',[
    'jquery',
    'underscore',
    'baseview',
    'pubsub',
    'state',
    'utils'
],
function(
    $,
    _,
    BaseView,
    PubSub,
    StateManager,
    Utils
) {
        /**
         * View class.
         */
        var AdFreeRedirectCard = BaseView.extend({

            /**
             * Initialize the view.
             */
            initialize: function() {

                this.body = Utils.get('body');

                StateManager.registerFullScreenView(this);

                this.buildModal();
            },

            buildModal: function() {
                var _this = this;

                StateManager.fetchHtml('/services/ad-free-redirect/').done(function(r) {
                    _this.body.append(r);
                    _this.m_uiModal = $("#cc_modal");
                    _this.m_uiModalBgrnd = $("#lightbox");

                    _this.m_uiModal.show();
                    _this.m_uiModalBgrnd.fadeIn(300);
                    _this.setElement('#ad_free_redirect_modal');
                    _this.startTimer();
                });
            },

            startTimer: function () {
                var el = document.getElementById('redirect_timer');
                var time = 5;
                var timer = setInterval(function(){
                    var s=time-- + '';
                    el.textContent= s+'s';
                    if (time < 0) {
                        clearInterval(timer);
                        el.textContent = 'Loading...';
                        window.location.reload();
                    }
                },1000);
            }
        });

        return AdFreeRedirectCard;
});

